import { getType } from "typesafe-actions";
import { transactionNoteActions, TTransactionNoteActionType } from "../../actions/entities/transaction-note.actions";
import { TransactionNoteState } from "../../types/state/entities/TransactionNoteState";
import { RequestState } from "../../constants/request-state";
import { user } from "../../user";
import { stringUtils } from "../../utils";


export const transactionNotesInitialState: TransactionNoteState = {
    notesByTransaction: {}
}

export function transactionNoteReducer(
    state = transactionNotesInitialState, action: TTransactionNoteActionType): TransactionNoteState {

    switch (action.type) {
        case getType(transactionNoteActions.requestNotes):
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [action.payload.transactionReferenceName]: {
                        requestState: RequestState.request,
                        notes: []
                    }
                }
            };
        case getType(transactionNoteActions.requestResult):
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [action.payload.transactionReferenceName]: {
                        requestState: action.payload.requestState,
                        notes: action.payload.notes
                    }
                }
            };
        case getType(transactionNoteActions.noteChanged): {
            const { transactionReferenceName, id } = action.payload.note;
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [transactionReferenceName]: {
                        ...state.notesByTransaction[transactionReferenceName],
                        notes: state.notesByTransaction[transactionReferenceName]?.notes.some(n => n.id === id)
                            ? state.notesByTransaction[transactionReferenceName]?.notes.map(n => n.id === id ? action.payload.note : n)
                            : state.notesByTransaction[transactionReferenceName]?.notes.concat(action.payload.note)
                    }
                }
            };
        };
        case getType(transactionNoteActions.noteReplyChanged): {
            const { transactionReferenceName, reply } = action.payload;
            const { noteId, id } = reply;
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [transactionReferenceName]: {
                        ...state.notesByTransaction[transactionReferenceName],
                        notes: state.notesByTransaction[transactionReferenceName]?.notes.map(n => n.id === noteId
                            ? {
                                ...n,
                                replies: n.replies.some(r => r.id === id)
                                    ? n.replies.map(r => r.id === id ? reply : r)
                                    : n.replies.concat(reply)
                            } : n)
                    }
                }
            };
        };
        case getType(transactionNoteActions.noteDeleted): {
            const { transactionReferenceName, noteId } = action.payload;
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [transactionReferenceName]: {
                        ...state.notesByTransaction[transactionReferenceName],
                        notes: state.notesByTransaction[transactionReferenceName].notes.filter(n => n.id !== noteId)
                    }
                }
            }
        };
        case getType(transactionNoteActions.noteReplyDeleted): {
            const { transactionReferenceName, noteId, replyId } = action.payload;
            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [transactionReferenceName]: {
                        ...state.notesByTransaction[transactionReferenceName],
                        notes: state.notesByTransaction[transactionReferenceName].notes.map(n => n.id === noteId
                            ? { ...n, replies: n.replies.filter(r => r.id !== replyId) }
                            : n
                        )
                    }
                }
            }
        };
        case getType(transactionNoteActions.myNotesDeleted): {
            const { transactionReferenceName } = action.payload;

            return {
                notesByTransaction: {
                    ...state.notesByTransaction,
                    [transactionReferenceName]: {
                        ...state.notesByTransaction[transactionReferenceName],
                        notes: state.notesByTransaction[transactionReferenceName].notes.filter(n =>
                            !stringUtils.equalsIgnoringCase(n.user.email, user.current()?.email ?? ''))
                    }
                }
            }

        }
        case getType(transactionNoteActions.reset):
            return { ...transactionNotesInitialState }
        default:
            return state;
    }
}